(function () {
  const root = document.querySelector("[data-product-section]");
  if (!root) return;

  const fmt = (window.JHT && window.JHT.formatMoney) || ((c) => "€" + (c / 100).toFixed(2));

  let variants = [];
  try {
    variants = JSON.parse(document.querySelector("[data-pdp-variants]").textContent);
  } catch (e) {
    variants = [];
  }

  const form = root.querySelector("[data-product-form]");
  const variantInput = root.querySelector("[data-variant-input]");
  const atc = root.querySelector("[data-atc]");
  const priceEl = root.querySelector("[data-pdp-price]");
  const groups = Array.from(root.querySelectorAll("[data-option]"));

  const posOf = (g) => parseInt(g.dataset.position, 10) - 1;

  // selected[positionIndex] = chosen value
  const selected = [];
  groups.forEach((g) => {
    const sel = g.querySelector("[data-opt].selected") || g.querySelector("[data-opt]");
    if (sel) selected[posOf(g)] = sel.dataset.value;
  });

  function matchesSelected(v) {
    return selected.every((val, i) => val == null || v.options[i] === val);
  }

  function findVariant() {
    const exact = variants.find((v) => selected.every((val, i) => v.options[i] === val));
    if (exact) return exact;
    return (
      variants.find((v) => v.available && matchesSelected(v)) ||
      variants.find((v) => matchesSelected(v)) ||
      variants[0]
    );
  }

  function availableWith(pos, val) {
    return variants.some((v) => {
      if (!v.available || v.options[pos] !== val) return false;
      return selected.every((sv, i) => i === pos || sv == null || v.options[i] === sv);
    });
  }

  function markSelection() {
    groups.forEach((g) => {
      const p = posOf(g);
      g.querySelectorAll("[data-opt]").forEach((b) =>
        b.classList.toggle("selected", b.dataset.value === selected[p])
      );
    });
  }

  function refreshAvailability() {
    groups.forEach((g) => {
      const p = posOf(g);
      g.querySelectorAll("[data-opt]").forEach((btn) => {
        const ok = availableWith(p, btn.dataset.value);
        btn.classList.toggle("is-soldout", !ok);
        if (btn.classList.contains("size")) {
          if (ok) btn.removeAttribute("disabled");
          else btn.setAttribute("disabled", "");
        }
      });
    });
  }

  function setVariant(v) {
    if (!v) return;
    if (variantInput) variantInput.value = v.id;
    if (atc) atc.dataset.variantId = v.id;
    if (priceEl) priceEl.textContent = fmt(v.price);
    if (atc) {
      const ok = v.available;
      atc.disabled = !ok;
      atc.textContent = ok
        ? (window.JHT && window.JHT.strings && window.JHT.strings.addToCart) || "Add to cart"
        : (window.JHT && window.JHT.strings && window.JHT.strings.soldOut) || "Sold out";
    }
    root.querySelectorAll("[data-option-current]").forEach((el) => {
      const g = el.closest("[data-option]");
      if (g) el.textContent = v.options[posOf(g)];
    });
  }

  groups.forEach((g) => {
    const p = posOf(g);
    g.querySelectorAll("[data-opt]").forEach((btn) => {
      btn.addEventListener("click", () => {
        if (btn.classList.contains("size") && btn.disabled) return;
        selected[p] = btn.dataset.value;
        const v = findVariant();
        if (v) v.options.forEach((val, i) => (selected[i] = val)); // sync to resolved variant
        markSelection();
        setVariant(v);
        refreshAvailability();
      });
    });
  });

  // initial sync
  const initial = findVariant();
  if (initial) initial.options.forEach((val, i) => (selected[i] = val));
  markSelection();
  setVariant(initial);
  refreshAvailability();

  // Warm-up strip: le foto oltre la seconda sono loading=lazy (non concorrono con
  // l'LCP) ma vanno scaldate dopo il load, sennò lo swipe le trova in ritardo
  function warmStrip() {
    root.querySelectorAll('.pdp-media img[loading="lazy"]').forEach((img) => {
      const pre = new Image();
      if (img.srcset) { pre.srcset = img.srcset; pre.sizes = img.sizes || ""; }
      pre.src = img.src;
    });
  }
  if (document.readyState === "complete") {
    warmStrip();
  } else {
    window.addEventListener("load", () => {
      ("requestIdleCallback" in window ? requestIdleCallback : setTimeout)(warmStrip);
    }, { once: true });
  }

  // Accordions (su mobile partono chiuse: inline script nella section, pre-paint)
  root.querySelectorAll(".accordion-head").forEach((head) => {
    head.addEventListener("click", () => {
      head.closest(".accordion").classList.toggle("open");
    });
  });

  // Add to cart
  function addCurrent() {
    const id = (atc && atc.dataset.variantId) || (variantInput && variantInput.value);
    if (!id || (atc && atc.disabled)) return;
    if (window.JHT && window.JHT.cart) {
      window.JHT.cart.add(id, 1);
    } else if (form) {
      form.submit();
    }
  }

  if (form) {
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      addCurrent();
    });
  } else if (atc) {
    atc.addEventListener("click", (e) => {
      e.preventDefault();
      addCurrent();
    });
  }
})();
